import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('solutionExchangeRate', 'solutionExchangeRates');

const customActions = {
  async LOAD_solutionExchangeRatesForSolution({ commit, rootGetters }, solutionId) {
    const data = await odata.o(rootGetters)
      .get('solutionExchangeRates')
      .query({ $filter: `IsDeleted eq false AND SolutionId eq ${solutionId}` });
    commit('SET_solutionExchangeRates', data);
    return data;
  },
};

export default { ...actions, ...customActions };
